import React from 'react'

import { FormOnChange, MyOptionType, Select } from '@procsea/design-system'

interface ClaimsSelectorProps {
  name?: string
  onChange: FormOnChange<boolean | null>
  value?: boolean | null
}

const CLAIMS_VISIBILITY_OPTIONS: MyOptionType<boolean>[] = [
  { label: gettext('With'), value: true },
  { label: gettext('Without'), value: false },
]

const ClaimsSelector = ({ name, onChange, value }: ClaimsSelectorProps) => (
  <Select<boolean, false>
    clearable
    data-e2e={'claims-visibility-select'}
    label={gettext('Claims')}
    minWidth="8rem"
    name={name}
    onChange={onChange}
    options={CLAIMS_VISIBILITY_OPTIONS}
    placeholder={gettext('Claims')}
    value={value}
  />
)

export default ClaimsSelector
